import React, {useEffect, useState} from 'react';
import BaseDialog from '../BaseDialog';
import useApiControl from '../../../common/useApiControl';
import ErrorDialog from '../ErrorDialog';
import { shortenDescription } from '../../../common/description';

const AddFollowRivalDialog = ({
  isVisible, onClose, dialogDatas, 
  isFollowed, addFollow, removeFollow,
  isRivals, addRivals, removeRivals,
  }) => {
  const [errorMessage, setErrorMessage] = useState('');

  const params = {
    id: dialogDatas?.targetUser.user_id,
  };

  const { data: data1, loading: loading1, executeRequest: executeRequest1 } = useApiControl({
      action: '/add_follow',
      params: params,
      method: 'POST',
  });

  const { data: data2, loading: loading2, executeRequest: executeRequest2 }  = useApiControl({
    action: '/remove_follow',
    params: params,
    method: 'POST',
});

const { data: data3, loading: loading3, executeRequest: executeRequest3 } = useApiControl({
  action: '/add_rivals',
  params: params,
  method: 'POST',
});

const { data: data4, loading: loading4, executeRequest: executeRequest4 }  = useApiControl({
action: '/remove_rivals',
params: params,
method: 'POST',
});

  const handleOnClick1 = () => {
    executeRequest1().catch((error) => {
      setErrorMessage(error?.response?.data?.error || 'エラーが発生しました。');
    });
    addFollow(dialogDatas.targetUser.user_id);
  }

  const handleOnClick2 = () => {
    executeRequest2().catch((error) => {
      setErrorMessage(error?.response?.data?.error || 'エラーが発生しました。');
    });
    removeFollow(dialogDatas.targetUser.user_id);
  }

  const handleOnClick3 = () => {
    executeRequest3().catch((error) => {
      setErrorMessage(error?.response?.data?.error || 'エラーが発生しました。');
    });
    addRivals(dialogDatas.targetUser.user_id);
  }

  const handleOnClick4 = () => {
    executeRequest4().catch((error) => {
      setErrorMessage(error?.response?.data?.error || 'エラーが発生しました。');
    });
    removeRivals(dialogDatas.targetUser.user_id);
  }

  useEffect(() => {
    onClose();
  }, [data1,data2,data3,data4]);

    return (
      <div>
        <ErrorDialog
          isVisible={Boolean(errorMessage)}
          message={errorMessage}
          onClose={() => setErrorMessage('')}
        />
        <BaseDialog
          isVisible={isVisible}
          onClose={() => onClose()}
        >

          {/* ユーザー基本情報表示ブロック */}
          <div style={{ padding: '12px', marginBottom: '12px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #ccc' }}>
            <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '8px' }}>
              {dialogDatas.targetUser.name}
            </div>
            <div style={{ fontSize: '14px', marginBottom: '4px' }}>
              このルームでのルームチップ: {dialogDatas.targetUser.point}
            </div>
            <div style={{ fontSize: '14px', marginBottom: '4px' }}>
              参加チケット: {dialogDatas.targetUser.ticket}枚
            </div>
            {dialogDatas.targetUser.description && (
              <div style={{ fontSize: '13px', color: '#555', marginTop: '8px', whiteSpace: 'pre-wrap' }}>
                「{shortenDescription(dialogDatas.targetUser.description, 20)}」
              </div>
            )}
          </div>
          {/* 自分がフォロワーかの判定 */}
          {(() => {
            const followList = JSON.parse(dialogDatas.targetUser.follow || '[]');
            return followList.includes(dialogDatas.user.id);
          })() && (
            <div style={{ fontSize: '13px', color: '#888', marginBottom: '12px' }}>
              このユーザーはあなたをフォローしています
            </div>
          )}
          {!isFollowed(dialogDatas.targetUser.user_id) && (
          <div
            style={{
              display: 'inline-block',
              padding: '8px 12px',
              margin: '6px 0',
              backgroundColor: '#e0f2ff',
              border: '1px solid #0077cc',
              borderRadius: '6px',
              color: '#0077cc',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
           onClick={() => handleOnClick1()}
          >
            このユーザーをフォロー(⋈◍＞◡＜◍)。✧♡
          </div>
          )}
          {isFollowed(dialogDatas.targetUser.user_id) && (
            <div
              style={{
                display: 'inline-block',
                padding: '6px 10px',
                margin: '6px 0',
                backgroundColor: '#f0f0f0',
                border: '1px solid #ccc',
                borderRadius: '6px',
                color: '#555',
                fontWeight: 'normal',
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
              }}
            onClick={() => handleOnClick2()}
          >
            このユーザーのフォローを外す
          </div>
          )}
          {!isRivals(dialogDatas.targetUser.user_id) && (
          <div
            style={{
              display: 'inline-block',
              padding: '8px 12px',
              margin: '6px 0',
              backgroundColor: '#fff3e0', // 明るいオレンジ背景
              border: '1px solid #ff9800', // 鮮やかなオレンジ
              borderRadius: '6px',
              color: '#ef6c00', // 強調されたオレンジ
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
           onClick={() => handleOnClick3()}
          >
            このユーザーをライバルとしてマークする
          </div>
          )}
          {isRivals(dialogDatas.targetUser.user_id) && (
            <div
              style={{
                display: 'inline-block',
                padding: '6px 10px',
                margin: '6px 0',
                backgroundColor: '#f0f0f0',
                border: '1px solid #ccc',
                borderRadius: '6px',
                color: '#555',
                fontWeight: 'normal',
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
              }}
            onClick={() => handleOnClick4()}
          >
            このユーザーのライバルマークを外す
          </div>
          )}
        </BaseDialog>
      </div>
    );
};

export default AddFollowRivalDialog;
